import { render, staticRenderFns } from "./CenterIframe.vue?vue&type=template&id=0cbcb2f0&scoped=true"
import script from "./CenterIframe.vue?vue&type=script&lang=js"
export * from "./CenterIframe.vue?vue&type=script&lang=js"
import style0 from "./CenterIframe.vue?vue&type=style&index=0&id=0cbcb2f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbcb2f0",
  null
  
)

export default component.exports